import React from 'react';
import { Switch } from '@headlessui/react'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function ToggleField({
  onChange,
  selected,
  label
}) {
  return (
    <div className='flex justify-between border-b-2 border-gray-100 pb-2'>
      <span className="text-lg text-secondary w-1/3 flex-grow">{label}</span>
      <div>
        <Switch
          checked={selected}
          onChange={onChange}
          className={classNames(
            selected ? 'bg-primary' : 'bg-gray-200',
            'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none'
          )}
        >
          <span className="sr-only">Use setting</span>
          <span
            aria-hidden="true"
            className={classNames(
              selected ? 'translate-x-5' : 'translate-x-0',
              'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
            )}
          />
        </Switch>
      </div>
    </div>
  )
}

export default ToggleField


